import { useDispatch, useSelector } from "react-redux"
import Pagination from "../pagination/Pagination"

import { getAttyStatusFromId, getCaseTypeFromId, getMRQStatusLabelFromId, getPracticeNameFromId } from "../../../../lib/labels"
import { checkIfLopIsRequired, formatCurrency } from "../../../../lib/script"
import { practicesFunctions } from "../../../../lib/practices"

import CustomSelect from "../../../common/interactive/CustomSelect"
import { gdqStatusOptions, workQueueRefreshApiTimeout } from "../../../../lib/systemData"
import { caseQuickUpdate } from "../../../../lib/fetchApi"
import { notificationActions } from "../../../../store/notifications"
import { workqueueActions } from "../../../../store/workqueue"

import HeaderCell from "../../cells/HeaderCell"
import HeaderCellGroup from "../../cells/HeaderCellGroup"
import NameCell from "../../cells/NameCell"
import VerificationBox from "./VerificationBox"
import NamePhoneCell from "../../cells/NamePhoneCell"
import PracticesUploadItem from "../../../patient/details/procodocs/practicesupload/PracticesUploadItem"
import CheckboxCell from "../../../common/interactive/CheckboxCell"

import classes from '../WorkQComponent.module.css'
import ExpandCell from "../../cells/ExpandCell"
import TextCellCopy from "../../cells/TextCellCopy"
import DateWithBox from "../../cells/DateWithBox"
import WorkQComponentLoading from "./WorkQComponentLoading"
import StatusCell from "../../cells/StatusCell"

export default function GDQWorkQ({workqSlug, patientsList}) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)

    async function updateHandler(data) {
        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            workq: workqSlug,
            fields: {
                [data.identifier.field] : data.data.value,
            }
        }     

        let update = await caseQuickUpdate(userToken, data.identifier.case_id, reqBody, null, true)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        } else {            
            dispatch(notificationActions.setError({errorMessage: `Your changes have been successfully saved to the case.`, type: 'success'}))
            setTimeout(() => {
                dispatch(workqueueActions.setRefreshApi())
            }, workQueueRefreshApiTimeout());
        }    
                
    }

    return <>
        <WorkQComponentLoading classes={classes}/>
        {patientsList && <>
            <div className={classes.normal_container}>
                {/* ${loading ? classes.table_body_loading : ''} */}
                <table className={`${classes.custom_table} ${classes.table_align_top} `}>
                    <thead>
                        <tr>
                            <th colSpan={2}>
                                <HeaderCellGroup item={{groupName: 'Demographic'}}/>                               
                            </th>    
                            <th colSpan={3}>
                                <HeaderCellGroup item={{groupName: 'Case'}} />
                            </th>                     
                            <th colSpan={2}>
                                <HeaderCellGroup item={{groupName: 'Attorney'}}/>
                            </th>
                            <th colSpan={2}>
                                <HeaderCellGroup item={{groupName: 'GDQ'}} />
                            </th>   
                                                
                            <th colSpan={8}>
                                <HeaderCellGroup item={{groupName: 'Practices'}}/>
                            </th>
                        </tr>
                        <tr>
                            {/* demographic  */}
                            <th>
                                <HeaderCell item={{name: 'NG #', group: 'patient', label: 'person_number', sortable: true}} />                                 
                            </th>
                            <th>
                                <HeaderCell item={{name: 'Patient Name', group: 'patient', label: 'name', sortable: true}} />                                 
                            </th> 

                            {/* case  */}
                            <th>
                                <HeaderCell item={{name: 'Type', group: 'case', label: 'case_type_id', sortable: true}} />                                
                            </th>
                            <th className="table-cell-fit">
                                <HeaderCell item={{name: 'Initial treatment', group: 'case', label: 'initial_treatment', sortable: true}} />                                
                            </th> 
                            <th className="table-cell-fit">
                                <HeaderCell item={{name: 'Return to Tx.', group: 'case', label: 'initial_treatment', sortable: false}} />                                
                            </th> 

                            {/* attorney    */}
                            <th>
                                <HeaderCell item={{name: 'Law Firm', group: 'attorney', label: 'law_firm', sortable: true}} />                                 
                            </th>
                            {/* <th>
                                <HeaderCell item={{name: 'Atty', group: 'attorney', label: 'attorney_name', sortable: true}} />                                 
                            </th>
                            <th>
                                <HeaderCell item={{name: 'Case Manager', group: 'attorney', label: 'case_manager', sortable: true}} />                                 
                            </th> */}
                            <th>
                                <HeaderCell item={{name: 'Status', group: 'attorney', label: 'status_id', sortable: true}} />                                
                            </th>  
                            
                            {/* gdq    */}
                            <th>
                                <HeaderCell item={{name: 'Status', group: 'case', label: 'gdq_status_id', sortable: true}} />                                 
                            </th>
                            <th >
                                <HeaderCell item={{name: 'Entry Date', group: 'work_queue_gdq_mrq', label: 'gdq_entry_date', sortable: true}} />                                
                            </th> 
                            {/* <th className="table-cell-fit">
                                <HeaderCell item={{name: 'Days in Q', group: 'work_queue_gdq_mrq', label: 'days_in_q', sortable: false}} />                                
                            </th>     */}
                      
                            {/* Practices */}
                            <th>Practice</th>
                            <th>Chart Number</th>
                            <th>Total Charges</th>     
                            <th>HIPPA</th>
                            <th>LOP</th>
                            <th>LOR</th>
                            <th>Status</th>                       
                            <th>MRQ Status</th>
                            {/* <th>Lien Status</th> */}
                            
                        </tr>
                    </thead>
                    <tbody >
                        {patientsList.data && patientsList.data.map(item => (

                            <tr key={item.case?.id}>
                                {/* demographic person #  */}                           
                                <td>
                                    {item.patient && item.patient.person_number && <>                                        
                                        <div className={`${classes.cell_row} ${classes.cell_row_flex}`}>
                                            <TextCellCopy text={item.patient.person_number}/>
                                        </div>
                                    </>}
                                </td>

                                {/* patient name  */}  
                                <td className={`${classes.td_cell_no_padding}`}>
                                    {item.patient && <>
                                        <NameCell slug={workqSlug} item={item} text={item.patient.name} group={{dob: item.patient.dob}} hideDrawer={true}/>                                
                                    </>}
                                </td>

                                {/* case type  */}
                                <td >
                                    {item.case && <>
                                        <div className={`${classes.cell_row} ${classes.cell_row_flex} ${classes.justify_centered}`}>{getCaseTypeFromId(item.case.case_type_id)}</div>
                                    </>}  
                                </td>
                                {/* initial treatment  */}
                                <td>
                                    {item.work_queue_gdq_mrq && <>
                                        <DateWithBox classes={classes} date={item.work_queue_gdq_mrq.gdq_entry_date}/>
                                    </>}
                                </td> 

                                {/* return to treatment  */}
                                <td>
                                    {item.case && <>
                                        <DateWithBox classes={classes} date={item.case.return_for_treatment_date}/>
                                    </>}
                                </td> 

                                {/* attorney law firm  */}
                                <td className={`${classes.td_cell_no_padding}`}>
                                    {item.attorney && <>
                                        {item.attorney.law_firm && <ExpandCell initialText={item.attorney.law_firm}>
                                            {item.attorney.attorney_name && <div className={classes.expand_cell_row}>
                                                <strong>Atty:</strong> <NamePhoneCell classes={classes} name={item.attorney.attorney_name} phone={item.attorney.attorney_phone} />
                                            </div>}
                                            {item.attorney.case_manager && <div className={classes.expand_cell_row}>
                                                <strong>CM:</strong> <NamePhoneCell classes={classes} name={item.attorney.case_manager} phone={item.attorney.case_manager_phone} />
                                            </div>}
                                        </ExpandCell>}
                                    </>}
                                </td>     

                                {/* atty status  */}
                                <td className={`${classes.td_cell_no_padding} ${!item.attorney && classes.no_data}`}>
                                    {item.attorney && <VerificationBox displayData={getAttyStatusFromId(item.attorney.status_id)} rowData={item} type={'atty'}/>}
                                </td> 

                                {/* GDQ status  */}
                                <td className={`${classes.td_cell_no_padding}`}>
                                    {item.case && <>
                                        <CustomSelect optionsData={gdqStatusOptions()} preSelectedValue={item.case.gdq_status_id} action={updateHandler} name={'gdq_status_id'} identifier={{type: 'case', field: 'gdq_status_id', type_id: null, folder: null, case_id: item.case?.id}} sameSizeAsContainer={true} minWidth={150}/>                                            
                                    </>}
                                </td>

                                <td>
                                    {item.work_queue_gdq_mrq && <>
                                        <DateWithBox classes={classes} date={item.work_queue_gdq_mrq.gdq_entry_date}/>
                                    </>}
                                </td>   

                                {/*  practices  */}
                                <td className={`${classes.td_cell_no_padding} `}>
                                    {item.practices && item.practices.map(practice => (
                                        <div key={practice.practice_id} className={`${classes.practice_cell} ${classes['height_' + item?.practices?.length]}`}>{getPracticeNameFromId(practice.practice_id)}</div>
                                    ))}                                    
                                </td>
                                <td className={`${classes.td_cell_no_padding}`}>
                                    {item.practices && item.practices.map(practice => (
                                        <div key={practice.practice_id} className={`${classes.practice_cell} ${classes['height_' + item?.practices?.length]}`}>{practice.chart_number}</div>
                                    ))}                                    
                                </td>
                                <td className={`${classes.td_cell_no_padding}`}>
                                    {item.practices && item.practices.map(practice => (
                                        <div key={practice.practice_id} className={`${classes.practice_cell} ${classes['height_' + item?.practices?.length]}`}>
                                            ${formatCurrency(practice.total_charges)}
                                        </div>
                                    ))}                                    
                                </td> 
                                <td className={`${classes.td_cell_no_padding}`}>
                                    {item.practices && item.practices.map(practice => (
                                        <div key={practice.practice_id} className={`${classes.practice_cell} ${classes.justify_centered} ${classes['height_' + item?.practices?.length]}`}>
                                            {/* <CheckboxCell setStyle={'centered'} checked={practice.has_hippa} isDisabled={true}/> */}
                                            <PracticesUploadItem practiceId={practice.practice_id} usedFor={'HIPAA'} uploadDisabled={true} caseAttorneyId={item?.attorney?.id} activeCase={item}/>
                                        </div>
                                    ))}                                    
                                </td>
                                <td className={`${classes.td_cell_no_padding}`}>
                                    {item.practices && item.practices.map(practice => (
                                        <div key={practice.practice_id} className={`${classes.practice_cell} ${classes.justify_centered} ${classes['height_' + item?.practices?.length]}`}>
                                            {checkIfLopIsRequired(item?.attorney, item) && practicesFunctions.isPracticeRequiresLOP(practice.practice_id) ? (
                                                <PracticesUploadItem practiceId={practice.practice_id} usedFor={'LOP'} uploadDisabled={true} caseAttorneyId={item?.attorney?.id} activeCase={item}/>
                                            ) : (
                                                <CheckboxCell checked={practice.has_lop ?? practice.lop} isDisabled={true} setStyle={'centered'}/>
                                            )}
                                        </div>
                                    ))}
                                </td>
                                <td className={`${classes.td_cell_no_padding}`}>
                                    {item.practices && item.practices[0] && <div className={`${classes.practice_cell} ${classes.justify_centered} ${classes.height_1}`}>
                                        <PracticesUploadItem practiceId={item.practices[0].practice_id} usedFor={'LOR'} uploadDisabled={true} caseAttorneyId={item?.attorney?.id} activeCase={item}/>
                                    </div>}
                                </td>  
                                   
                                <td className={`${classes.td_cell_no_padding}`}>
                                    {item.practices && item.practices.map(practice => (
                                        <div key={practice.practice_id} className={`${classes.practice_cell} ${classes.practice_cell_no_padding} ${classes['height_' + item?.practices?.length]}`}>
                                            {/* {getTreatmentStatusLabelFromId(practice.status_id)}  */}
                                            <StatusCell data={practice.status_id} group={'practices'} itemKey={'case_practices_status'} caseData={item} workqSlug={workqSlug} />
                                        </div>
                                    ))}  
                                       
                                </td>                            
                                <td className={`${classes.td_cell_no_padding}`}>
                                    {item.practices && item.practices.map(practice => (
                                        <div key={practice.practice_id} className={`${classes.practice_cell} ${classes['height_' + item?.practices?.length]}`}>
                                            {getMRQStatusLabelFromId(practice.mrq_status_id)} 
                                        </div>
                                    ))}  
                                </td>
                                                     
                            
                            </tr>
                        ))}
                    </tbody>
                    
                </table>
            </div>

            
            {patientsList.meta && <div className={classes.pagination_container}>
                {patientsList  && <Pagination data={patientsList} apiType={workqSlug} />}
            </div>}
        </>}
    </>
}